import React, { Component } from 'react';
import { Alert, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

class Fallback extends Component {

    render() {
        const {
            companyDetails,
        } = this.props;
        const companyName = companyDetails && companyDetails.data != null ? companyDetails.data.description : '';
        return <Row className="h-100 d-flex align-items-center justify-content-center public-user-page">
            {companyName ? (
                <h4 className="brand-name player">{companyName}</h4>
            ) : (
                <h4 className="brand-name player">
                    APTO<span className="ats">.AI</span>
                </h4>
            )}
            <Col xs="12" sm="10" md="4">
                <Alert color="danger text-center"> Link has expired </Alert> <Link className="mt-4 d-block text-center bg-white p-2 rounded" to='login' > Continue to login </Link>
            </Col>
        </Row>
    }
}

export default Fallback;